import React, {useContext, useState} from 'react';
import block from 'bem-cn-lite';
import {Button, Icon, Popup, Text, Tooltip} from '@gravity-ui/uikit';
import {ChevronDown, PersonPlanetEarth} from '@gravity-ui/icons';
import {AppContext} from '@app/context/context';
import {loginAsClientFunc} from '@components/Header/LoginAsClient/services/loginAsClientService';
import {usePopoverAuxControls} from '@frontend/shared';
import {PopupTypeEntrance} from './components/PopupTypeEntrance';
import {hasAnyRole} from '@utils';

import './LoginAsClient.scss';

const b = block('login-as-client');

export const LoginAsClient = () => {
    const {state} = useContext(AppContext);
    const [error, setError] = useState<string | null>(null);
    const {open, buttonRef, toggleOpen, closePopover} = usePopoverAuxControls();
    const isDisabled = !(state.selectedClient?.isSelected ?? false);
    const clientLogin = state.selectedClient?.client;

    const isSuperadmin = hasAnyRole(state.user, ['superadmin']);

    const handleLoginAsClient = async () => {
        if (!clientLogin) return;

        setError(null);
        const errorMessage = await loginAsClientFunc(clientLogin, 'prod');

        if (errorMessage) {
            setError(errorMessage);
        }
    };

    const handleMouseEnter = () => {
        if (error) {
            setError(null);
        }
    };

    const tooltipContent = (text: string) => (
        <Text variant="body-1" className={b('tooltip-content', {error: !!error})}>
            {error || text}
        </Text>
    );

    return (
        <div className={b()} ref={buttonRef}>
            <Tooltip
                content={tooltipContent('Войти под клиентом')}
                contentClassName={b('tooltip')}
                className={b('tooltip-container', {error: !!error})}
                placement="bottom-start"
                openDelay={0}
                closeDelay={0}
                disabled={isDisabled}
            >
                <div onMouseEnter={handleMouseEnter}>
                    <Button
                        size="xl"
                        view="normal"
                        disabled={isDisabled}
                        onClick={handleLoginAsClient}
                        pin={isSuperadmin ? 'round-brick' : 'round-round'}
                    >
                        <Icon data={PersonPlanetEarth} size={20} />
                    </Button>
                </div>
            </Tooltip>

            {isSuperadmin && (
                <>
                    <Tooltip
                        content={tooltipContent('Выбрать тип входа')}
                        contentClassName={b('tooltip')}
                        className={b('tooltip-container', {error: !!error})}
                        placement="bottom-start"
                        openDelay={0}
                        closeDelay={0}
                        disabled={isDisabled || open}
                    >
                        <div onMouseEnter={handleMouseEnter}>
                            <Button
                                size="xl"
                                view="normal"
                                disabled={isDisabled}
                                onClick={toggleOpen}
                                pin="brick-round"
                                className={b('type-button', {open})}
                                selected={open}
                                extraProps={{
                                    'aria-haspopup': 'menu',
                                    'aria-expanded': open
                                }}
                            >
                                <Icon data={ChevronDown} size={20} />
                            </Button>
                        </div>
                    </Tooltip>

                    <Popup
                        anchorRef={buttonRef}
                        onClose={closePopover}
                        open={open}
                        placement="bottom-start"
                        className={b('popup')}
                    >
                        <PopupTypeEntrance
                            onClose={closePopover}
                            clientLogin={clientLogin}
                            textClassName={b('popup-text')}
                            onError={setError}
                        />
                    </Popup>
                </>
            )}
        </div>
    );
};
